import React, { useState } from "react";
import { TouchableOpacity, Text, StyleSheet, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { FlatList } from "react-native-gesture-handler";

type SearchResultProps = {
  searchEvent: string;
  setSelectedCategory: (category: string) => void;
};

const SearchResult: React.FC<SearchResultProps> = ({
  searchEvent,
  setSelectedCategory,
}) => {
  const deviceSize = useDeviceSize();
  const [arrSearchResult, setArrSearchResult] = useState([
    { id: 0, title: "All", isSelected: 1 },
    { id: 1, title: "Users", isSelected: 0 },
    { id: 2, title: "Challenge", isSelected: 0 },
    // { id: 3, title: "tournament", isSelected: 0 },
    // { id: 4, title: "genre", isSelected: 0 },
    { id: 3, title: "game", isSelected: 0 },
  ]);

  return (
    <View style={{}}>
      <Text style={[AppFontStyle.BOLD_ANYBODY_14, { color: AppColors.white }]}>
        Search Result for “{searchEvent}”
      </Text>

      <FlatList
        data={arrSearchResult}
        style={{ gap: 8, marginTop: 8 }}
        key={
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? 4
            : 10
        }
        numColumns={
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? 4
            : 10
        }
        columnWrapperStyle={{
          // flex: 1,
          gap: 8,
        }}
        renderItem={({ item, index }) => (
          <TouchableOpacity
            style={{
              flexDirection: "row",
              paddingVertical:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 5
                  : 10,
              marginBottom: 8,
              gap: 5,
              backgroundColor: !item.isSelected
                ? AppColors.appViolentColor_6D08C3
                : AppColors.gray_C3C3C3,
              borderRadius: 25,
            }}
            onPress={() => {
              setSelectedCategory(item.title);
              const tempArr = [...arrSearchResult];
              tempArr.map((item) => {
                item.isSelected = 0;
              });
              tempArr[index].isSelected = 1;
              setArrSearchResult(tempArr);
            }}
          >
            <View>
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? AppFontStyle.BOLD_ANYBODY_12
                    : AppFontStyle.BOLD_ANYBODY_14,
                  {
                    color: AppColors.white,
                    paddingHorizontal:
                      deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                        ? 10
                        : 20,
                  },
                ]}
              >
                {item.title}
              </Text>
            </View>
          </TouchableOpacity>
        )}
      />
    </View>
  );
};

export default SearchResult;
